import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectProductAndResultType, selectSingleFamily } from '../redux/selectors';
import getDefaultProductType from '../services/productTypeService';
import getDefaultResultType from '../services/resultTypeService';
import { searchParametersSlice } from '../redux/slices';

export default class SingleFamilyHousingType {
  constructor() {
    this.selector = '[data-housing-type="singleFamily"]';
    store$.pipe(map(selectSingleFamily), distinctUntilChanged()).subscribe(this.onSingleFamilyChange.bind(this));

    store$.pipe(map(selectProductAndResultType), distinctUntilChanged())
      .subscribe(this.onProductAndResultTypeChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a fetchSingleFamily action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.fetchSingleFamily(payload));
  }

  /**
   * Gets the node element of single family box.
   * @returns {Node} element.
   */
  getNode() {
    return document.querySelector(this.selector);
  }

  /**
   * getSearchCommands: Gets the search command property of this Housing Box.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      productType: this.productTypeToApply,
      resultType: this.resultTypeToApply,
      singleFamily: this.singleFamilyToApply,
    };

    return searchCommandPropertyStructure;
  }

  /**
   * The function updates the product type to apply based on the selected product and result type.
   * @param productAndResultType - It represents the object with the product and result type.
   */
  onProductAndResultTypeChange(productAndResultType) {
    const { resultType, productType} = productAndResultType;
    this.productTypeToApply = getDefaultProductType(productType, resultType);
    this.resultTypeToApply = getDefaultResultType(resultType);
  }

  /**
   * The function toggles a box based on the value of the singleFamily parameter.
   * @param singleFamily - The singleFamily parameter is a boolean value that represents whether the
   * property is a single-family home or not.
   */
  onSingleFamilyChange(singleFamily) {
    this.singleFamilyToApply = !singleFamily;
    this.toggleSelect(singleFamily);
  }

  /**
   * The select function adds or removes the 'active' class from a node based on the value of the
   * singleFamily property.
   */
  toggleSelect(singleFamily) {
    const node = this.getNode();
    if (singleFamily) {
      node.selected = true;
    } else {
      node.selected = false;
    }
  }
}
